import React from 'react'

const AutomationOptionsInfoAndReminders = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className={className}>
    <path
      d="M41.36 1.5H7.82C4.32956 1.5 1.5 4.32956 1.5 7.82V41.36C1.5 44.8504 4.32956 47.68 7.82 47.68H41.36C44.8504 47.68 47.68 44.8504 47.68 41.36V7.82C47.68 4.32956 44.8504 1.5 41.36 1.5Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M16.3105 11.88H40.3805" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16.3105 20.26H35.0205" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16.3105 28.65H37.4205" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path d="M16.3105 37.03H30.6605" stroke="black" strokeWidth="1.5" strokeLinejoin="round" />
    <path
      d="M10.3391 13.43C11.1951 13.43 11.8891 12.736 11.8891 11.88C11.8891 11.0239 11.1951 10.33 10.3391 10.33C9.48302 10.33 8.78906 11.0239 8.78906 11.88C8.78906 12.736 9.48302 13.43 10.3391 13.43Z"
      fill="black"
    />
    <path
      d="M10.3391 21.81C11.1951 21.81 11.8891 21.116 11.8891 20.26C11.8891 19.4039 11.1951 18.71 10.3391 18.71C9.48302 18.71 8.78906 19.4039 8.78906 20.26C8.78906 21.116 9.48302 21.81 10.3391 21.81Z"
      fill="black"
    />
    <path
      d="M10.3391 30.2C11.1951 30.2 11.8891 29.506 11.8891 28.65C11.8891 27.7939 11.1951 27.1 10.3391 27.1C9.48302 27.1 8.78906 27.7939 8.78906 28.65C8.78906 29.506 9.48302 30.2 10.3391 30.2Z"
      fill="black"
    />
    <path
      d="M10.3391 38.85C11.1951 38.85 11.8891 38.156 11.8891 37.3C11.8891 36.444 11.1951 35.75 10.3391 35.75C9.48302 35.75 8.78906 36.444 8.78906 37.3C8.78906 38.156 9.48302 38.85 10.3391 38.85Z"
      fill="black"
    />
  </svg>
)

export default AutomationOptionsInfoAndReminders
